export enum ETableAlign {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right',
}

export enum ETableSortDirection {
    ASC = 'asc',
    DESC = 'desc',
}

export enum ETableFilterOperator {
    EQUALS = 'equals',
    CONTAINS = 'contains',
    STARTS_WITH = 'startsWith',
    ENDS_WITH = 'endsWith',
    GREATER_THAN = 'greaterThan',
    LESS_THAN = 'lessThan',
}

export enum ETableActionColor {
    PRIMARY = 'primary',
    ACCENT = 'accent',
    WARN = 'warn',
}
